import { html, LitElement } from 'lit';
import pulseTracker from '@finn-no/pulse-sdk';
import '@fabric-ds/icons/elements/messages-16';

class FinnContactButton extends LitElement {
    static get properties() {
        // reason for change: https://newbedev.com/syntaxerror-unexpected-token-expected-a-or-a-after-a-parameter-declaration-in-safari
        return {
            buttonText: { type: String },
            isAdOwner: { type: Boolean },
            showError: { type: Boolean },
            buttonVariant: { type: String },
            loginId: { type: Number },
            hasButtonIcon: { type: String },
            textAlignButton: { type: String },
            addVerticalMargin: { type: String },
        };
    }

    constructor() {
        super();
        this.isAdOwner = '';
        this.unknownDisableReason = false;
        this.buttonVariant = 'PRIMARY';
        this.buttonText = 'Send melding';
        this.showError = false;
        this.loginId = '';
        this.adId = '';
        this.hasButtonIcon = 'false'; // values: true or false. true when the button has icon
        this.textAlignButton = 'CENTER'; // values: CENTER, START and END
        this.addVerticalMargin = 'false'; // values: true or false. true adds 10px margin on top and bottom
    }

    connectedCallback() {
        super.connectedCallback();
        // Fetch the meta data in the script tag rendered by the server
        const element = document.getElementById('contact-button-data');
        try {
            const data = JSON.parse(element.textContent);
            this.url = data.url;
            this.name = data.name;
            this.buttonVariant = data.buttonVariant
                ? data.buttonVariant
                : this.buttonVariant;
            this.buttonText = data.buttonText
                ? data.buttonText
                : this.buttonText;
            this.loginId = data.loginId;
            this.isAdOwner = data.isAdOwner;
            this.adId = data.adId;

            if (this.loginId && this.isAdOwner) {
                this.showError = JSON.parse(
                    window.localStorage.getItem('showError'),
                );
                window.localStorage.removeItem('showError');
            } else {
                this.showError = false;
                window.localStorage.setItem('showError', this.showError);
                window.localStorage.removeItem('showError');
            }
        } catch (error) {
            this.unknownDisableReason = true;
        }
    }

    getButtonClassNames() {
        let buttonClass = 'button--primary';
        let buttonTextAlignClass = 'justify-center';
        let addVerticalMargin;
        if (this.buttonVariant === 'SECONDARY') {
            buttonClass = 'button--secondary';
        }
        if (this.buttonVariant === 'FLAT') {
            buttonClass = 'button--flat';
        }
        if (this.textAlignButton === 'START') {
            buttonTextAlignClass = 'justify-start';
        }
        if (this.textAlignButton === 'END') {
            buttonTextAlignClass = 'justify-end';
        }
        if (this.addVerticalMargin === 'true') {
            addVerticalMargin = 'my-10';
        }
        return `button flex items-center ${buttonClass} ${buttonTextAlignClass} ${addVerticalMargin} w-full max-w-none`;
    }

    iconTemplate() {
        let iconTemplate;
        if (this.hasButtonIcon === 'true') {
            iconTemplate = html`
                <f-icon-messages16 class="contents"></f-icon-messages16>
            `;
        }
        return iconTemplate;
    }

    buttonTemplate() {
        return html`
            <button
                    ?disabled=${this.disabled}
                    title=${this.unknownDisableReason ? 'En feil har oppstått' : ''}
                    class="${this.getButtonClassNames()}"
                    @click="${this.errorCheck}"
            >
                ${this.iconTemplate()}
                <p class="m-0 text-16 mx-12">${this.buttonText}</p>
            </button>
        `;
    }

    linkTemplate() {
        return html`
            <a
                    rel="nofollow"
                    href="${this.url}"
                    class="${this.getButtonClassNames()}"
                    @click="${this.trackButtonClick}"
            >
                ${this.iconTemplate()}
                <p class="m-0 text-16 mx-12">${this.buttonText}</p>
            </a>
        `;
    }

    errorTemplate() {
        let errorTemplate;
        if (this.showError) {
            errorTemplate = html`
                <p
                        class="text-red-500 text-center my-4 text-12"
                        id="send-message-own-ad-error-msg"
                >
                    Oi sann! Du kan ikke sende melding til deg selv.
                </p>
            `;
        }
        return errorTemplate;
    }

    getFinalTemplate() {
        if (this.isAdOwner || this.disabled) {
            return html`${this.buttonTemplate()}${this.errorTemplate()}`;
        }
        return html`${this.linkTemplate()}`;
    }

    render() {
        return html`
            <link
                    href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css"
                    rel="stylesheet"
                    type="text/css"
            />
            <div>${this.getFinalTemplate()}</div>
        `;
    }

    errorCheck() {
        this.showError = true;
    }

    trackButtonClick() {
        if (!this.loginId) {
            window.localStorage.setItem('showError', true);
        }
        // Calling the tracker is not required when the user is the ad owner.
        pulseTracker.trackEvent({
            type: 'Click',
            intent: 'Create',
            name: 'Send message',
            object: {
                id: 'sendMessageButton',
                type: 'UIElement',
                elementType: 'Button',
                items: [
                    {
                        type: 'ClassifiedAd',
                        id: this.adId,
                        contentId: this.adId,
                        name: 'n/a',
                        category: 'n/a',
                        hasExtendedProfile: 'false',
                    },
                ],
                page: {
                    type: 'ClassifiedAd',
                },
            },
            target: {
                id: 'id',
                type: 'Message',
            },
        });
    }
}

customElements.define('finn-contact-button', FinnContactButton);
